import { jsx as _jsx } from "react/jsx-runtime";
import React, { useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import { ToggleButtonGroup } from 'ziphy-web-shared/basic/lib/forms/fields';
import { useDefinitionSelectItems } from 'ziphy-web-shared/basic/lib/forms/fields/select/Select.hooks';
import { getToggleButtonGroupProps } from '../';
import styles from './ToggleButtonDefault.module.scss';
import ToggleButtonPlain from './ToggleButtonPlain';
const ToggleButtonDefault = ({ $element }) => {
    const { config, renderType, field } = $element;
    const { fieldProps } = useMemo(() => getToggleButtonGroupProps($element, []), [config]);
    const selectIdOptions = useDefinitionSelectItems(config.selectId);
    const items = (selectIdOptions === null || selectIdOptions === void 0 ? void 0 : selectIdOptions.length) ? selectIdOptions : config.options || [];
    if (renderType === 'plain') {
        return (_jsx(ToggleButtonPlain, { field: field, items: items, 
            // @ts-ignore
            withText: $element.renderParams.withText }));
    }
    return (_jsx(ToggleButtonGroup, Object.assign({ field: field, options: items }, fieldProps, { connectedGroupClassName: styles.group })));
};
export default observer(ToggleButtonDefault);
